import {useEffect} from 'react';

export function usePreventPullToRefresh() {
    useEffect(() => {
        const isMobile = window.innerWidth <= 767;
        let styleElement: HTMLStyleElement;
        if (isMobile) {
            styleElement = document.createElement('style');
            styleElement.innerHTML = `
            html, body {
                overscroll-behavior: none;
            }
            `;
            document.head.appendChild(styleElement);
        }

        return () => {
            if (styleElement) {
                document.head.removeChild(styleElement);
            }
        };
    }, []);
}
